import { useMemo } from 'react'
import { rowKey } from './rowAnchor'
import { type RequestComment } from './revisionRequest'

// Splits a request's comments into the ones anchored to a row still in the
// plan (grouped by row key, for RowCommentThread) and the orphans whose row
// is gone (for OrphanCommentsBlock). Shared by the commenting page and the
// task form, which both render the same tables read differently.
export function useRequestComments(comments: RequestComment[]) {
  const byRow = useMemo(() => {
    const map = new Map<string, RequestComment[]>()
    comments.forEach((c) => {
      if (!c.row_id) return
      const key = rowKey({ section: c.section, anchor_id: c.row_id })
      map.set(key, [...(map.get(key) ?? []), c])
    })
    return map
  }, [comments])
  const orphans = useMemo(() => comments.filter((c) => !c.row_id), [comments])

  return { byRow, orphans }
}
